import request from '@/utils/request'

let BalanceApi = {
    /*获取余额设置*/
    getSettings(data, errorback) {
        return request._get('/shop/user.balance/setting', data, errorback);
    },
    /*修改余额设置*/
    setSettings(data, errorback) {
        return request._post('/shop/user.balance/setting', data, errorback);
    },
    /*获取积分列表*/
    getBalanceLog(data, errorback) {
        return request._get('/shop/user.balance/log', data, errorback);
    },
    /*充值套餐*/
    listPlan(data, errorback) {
        return request._post('/shop/user.plan/index', data, errorback);
    },
    /*添加套餐*/
    addPlan(data, errorback) {
        return request._get('/shop/user.plan/add', data, errorback);
    },
    /*修改套餐*/
    editPlan(data, errorback) {
        return request._post('/shop/user.plan/edit', data, errorback);
    },
    /*删除套餐*/
    deletePlan(data, errorback) {
        return request._get('/shop/user.plan/delete', data, errorback);
    },
    /*充值记录*/
    log(data, errorback) {
        return request._post('/shop/user.plan/log', data, errorback);
    },
    /*提现申请*/
    cash(data, errorback) {
        return request._post('/shop/user.cash/index', data, errorback);
    },
    /*分销商提现审核*/
    cashSubmit(data, errorback) {
        return request._post('/shop/user.cash/submit', data, errorback);
    },
    /*分销商提现批量审核*/
    cashBatchSubmit(data, errorback) {
        return request._post('/shop/user.cash/batch_submit', data, errorback);
    },
    /*商家转账到零钱详情*/
    transfersDetail(data, errorback) {
        return request._post('/shop/user.cash/transfers_detail', data, errorback);
    },
    /*微信打款*/
    WxPay(data, errorback) {
        return request._post('/shop/user.cash/wechat_pay', data, errorback);
    },
    /*分销商确认打款*/
    money(data, errorback) {
        return request._post('/shop/user.cash/money', data, errorback);
    },
    /*分销商批量确认打款*/
    batchMoney(data, errorback) {
        return request._post('/shop/user.cash/batch_money', data, errorback);
    },
}
export default BalanceApi;



// WEBPACK FOOTER //
// ./src/api/balance.js